import { call, put, select } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { editingCourseActions, updateCourseActions } from "../slices";
import { toast } from "react-toastify";

function* updateCourseWorker({ payload }) {
  try {
    yield put(updateCourseActions.pending());

    yield put(editingCourseActions.splitUnits());

    const editingCourse = yield select((state) => state.course.editingCourse);
    // const { thumbnailImg, previewVideo } = editingCourse;

    // const newSections = [...course.sections].map((section) => {
    //   const newLectures = section.lectures.map((lecture) => {
    //     const newLecture = { ...lecture };
    //     delete newLecture.id;
    //     return newLecture;
    //   });
    //   const newSection = { ...section };
    //   delete newSection.id;
    //   return { ...newSection, lectures: newLectures };
    // });

    // const newCourse = { ...course, sections: newSections };
    // let additionalInfo = {};

    // if (thumbnailImg) {
    //   const uploadImageResponse = yield call(
    //     uploadAPI.uploadImage,
    //     thumbnailImg
    //   );
    //   const urlImg = uploadImageResponse.url;
    //   additionalInfo = { ...additionalInfo, thumbnailUrl: urlImg };
    // }

    // if (previewVideo) {
    //   const uploadVideoResponse = yield call(
    //     uploadAPI.uploadVideo,
    //     previewVideo
    //   );
    //   const urlVideo = uploadVideoResponse.url;
    //   additionalInfo = { ...additionalInfo, previewVideoUrl: urlVideo };
    // }
    const response = yield call(courseAPI.updateCourse, {
      ...editingCourse,
      // ...additionalInfo,
    });

    // yield put(editingCourseActions.setOldSection());

    // const newSections = response.data.sections.map((section) => {
    //   const lectures = section.lectures.map((lecture) => {
    //     return { ...lecture, type: SECTION_ITEM_TYPE.LECTURE };
    //   });
    //   const quizzes = section.quizzes.map((quiz) => {
    //     return { ...quiz, type: SECTION_ITEM_TYPE.QUIZ };
    //   });
    //   const assignments = section.assignments.map((assignment) => {
    //     return { ...assignment, type: SECTION_ITEM_TYPE.ASSIGNMENT };
    //   });

    //   const units = [...lectures, ...quizzes, ...assignments];
    //   // sorting units by index
    //   units.sort((a, b) => a.index - b.index);
    //   return {
    //     ...section,
    //     units,
    //   };
    // });

    // yield put(editingCourseActions.updateSections(newSections));

    // const { sections } = yield select((state) => state.course.editingCourse);
    // let dif = lodash.differenceWith(sections, newSections, lodash.isEqual);
    // console.log(dif);

    yield put(updateCourseActions.success(response));
    // const courseHasNoChange = lodash.isEqual(sections, newSections);
    // if (courseHasNoChange) {
    //   yield put(editingCourseActions.updateSections(newSections));
    //   yield put(updateCourseActions.success(response));
    // }

    // yield put(editingCourseActions.resetEditingCourse());

    if (payload?.isPublish) {
      if (payload.isActive == true) {
        payload?.redirectUpdate();
        toast.success("Update Course Successfully");
      }
      if (payload.isActive == false) {
        payload?.redirectCreate();
        toast.success("Create Course Successfully");
      }
    }
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(updateCourseActions.failure(error));
    toast.error("Update course failed!");
    // TODO: handle callback | onFailure
  }
}

export { updateCourseWorker };
